<style scoped="scoped" lang="scss">
/deep/.el-dialog .el-dialog__body {
  //max-height: calc(86vh - 112px);
  padding: 0 0 40px 68px;
}
	.production-monthly {

		.panel {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-wrap: nowrap;
			background: #F7F8FA;
			color: #909399;
			height: 28px;
			line-height: 28px;
			// min-width: 1000px;
			width: 100%;
			flex-shrink: 0;

			// 效率信息说明
			.info {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				flex-wrap: nowrap;
				background: #F7F8FA;
				color: #909399;
				height: 28px;
				line-height: 28px;
				// min-width: 1000px;
				width: 100%;
				flex-shrink: 0;

				.info-item-1 {
					max-width: 300px;
					min-width: 280px;
					height: 28px;
					flex-shrink: 0;
				}

				.info-item-2 {
					max-width: 280px;
					height: 28px;
					flex-shrink: 0;
				}

				.info-item-3 {
					width: 100%;
					text-align: right;
					color: #419FFF;
				}
			}

		}

		// 效率表单
		.form {
			margin-top: 12px;

			// 标记点
			.percent-box {
				margin-top: 8px;
				display: flex;
				flex-wrap: nowrap;
				align-items: center;
				min-width: 1000px;
				flex-wrap: wrap;

				.percent-input {
					display: flex;
					flex-wrap: nowrap;
					align-items: center;
				}

				.percent-input1 {
					display: flex;
					flex-wrap: nowrap;
					align-items: center;
					margin-left: 35px;
				}

				.border {
					// border: 1px solid #E5E5E5;
					width: 60px;
					height: 28px;
					border-radius: 5px;
					margin-left: 12px;
					text-align: center;
				}

				.mark {
					font-family: Microsoft YaHei UI;
					font-size: 14px;
					color: #606266;
				}

				.border:focus {
					outline: none;
					border: 1px solid rgb(65, 159, 255);
				}

				.text-word {
					font-family: Microsoft YaHei UI;
					font-size: 14px;
					color: #606266;
					margin-left: 26px;
				}

				.percent {
					display: flex;
					flex-wrap: nowrap;
					color: #4d4d4d;
					margin-left: 12px;
				}
			}
		}

		// 详细指标
		.detail-target {
			margin-top: 24px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			// 左侧
			.left {
				display: flex;
				align-items: center;

				.icon {
					display: inline-block;
					width: 5px;
					height: 16px;
					background: #419FFF;
				}

				.txt {
					display: inline-block;
					font-weight: 400;
					font-size: 16px;
					color: #303133;
					margin-left: 12px;
				}
			}

			// 右侧
			.right {
				display: flex;
				align-items: center;
			}
		}

		// 图表和表格
		.echart-table {
			margin-top: 8px;
			margin-bottom: 119px;
		}

		// 产品详情
		.production-detail {
			width: 100%;
			padding-left: 40px;
			// padding-right: 40px;
			color: #808184;
			margin-bottom: 34px;

			// 设备信息
			.equip-info {
				width: 40%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 14px;
				color: #606266;
			}

			// 时间信息
			.time-info {
				width: 70%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-top: 20px;

				.item {
					flex: 1;
					display: flex;
					flex-direction: column;

					.title {
						width: 100;
						height: 50%;
						padding: 10px;
						display: flex;
						flex-direction: row;
						flex-wrap: nowrap;
						align-items: center;
						// margin-bottom: 15px;
						margin-left: -22px;

						.sign {
							position: static;
							width: 5px;
							height: 16px;
							left: 0px;
							top: 3px;
							// background: #419FFF;
							flex: none;
							order: 0;
							flex-grow: 0;
							margin: 0px 12px;
						}

						.txt {
							font-size: 14px;
							font-family: Microsoft YaHei UI;
							line-height: 22px;
							color: #303133;
						}
					}

					.num {
						width: 100%;
						height: 50%;
						color: #808184;
						font-size: 20px;
						line-height: 20px;
						font-weight: bold;
						margin-left: 15px;
					}
				}

				.color-green {
					background: #64C136;
				}

				.color-orange {
					background: #E49D31;
				}

				.color-red {
					background: #F56D6D;
				}

				.color-gray {
					background: #8C8F95;
				}
			}

			// 表格
			.table {
				width: calc(100% - 40px);
				margin-top: 18px;

				.main {
					display: flex;
					justify-content: space-around;
					align-items: center;
					flex-wrap: wrap;
					width: 100%;
					padding: 5px;
					color: #909399;

					.item {
						width: 50%;
						padding: 18px;
						display: flex;
						justify-content: space-between;
						align-items: center;

						.label {
							width: 50%;
							margin-left: -15px;
							font-size: 14px;
						}

						.value {
							width: 80%;
							font-size: 14px;
						}
					}
				}
			}
		}
	}
</style>
<template>
	<div class="production-monthly">
		<div class="panel">
			<!-- 信息说明 -->
			<div class="info">
				<div class="info-item-1">
				</div>
				<div class="info-item-2">
				</div>
				<div class="info-item-3">
					{{ $t('meiri11:00gengxinzuorishuju') }}
				</div>
			</div>
		</div>
		<!-- 表单 -->
		<div class="form">
			<div ref="search1">
				<el-form :style="{height: screenWidth > 1232 ? '28px': ''}" :model="equipmentProduction.searchForm" :inline="true" size="mini">
					<el-form-item :label="$t('xuanzeyuefen')">
						<el-date-picker v-model="equipmentProduction.searchForm.time" :clearable="false"
							value-format="yyyy-MM" type="month" :placeholder="$t('xuanzeyuefen')">
						</el-date-picker>
					</el-form-item>
					<el-form-item :label="$t('suoshuzuzhi')">
						<yi_data_select :type="'organization'" :idsPath.sync="equipmentProduction.searchForm.orgId"
							:ids.sync="equipmentProduction.searchForm.orgIds">
						</yi_data_select>
					</el-form-item>
					<el-form-item :label="$t('shebeimingcheng')" size="mini">
						<yi_cross_select multiple :component="'web_base_equipment_list'"
							:ids.sync="equipmentProduction.searchForm.equipmentId">
						</yi_cross_select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getEquipmentBasicReport" plain>
							{{ $t('sousuo') }}
						</el-button>
						<el-button type="default" @click="resetEquipmentProduction" plain style="margin-left: 10px;">
							{{ $t('chongzhi') }}
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<!-- 详细指标 -->
		<div class="detail-target">
			<div class="left">
				<span class="icon"></span>
				<span class="txt">{{$t('xiangxizhibiao')}}</span>
			</div>
			<div class="right">
				<el-button size="mini" style="margin-right:1px" icon="yicon yicon-export" :loading="exportLoading" :title="$t('daochu')" 
					@click="exportBasicProductionExcel()">
				</el-button>
				<el-button size="mini" type="default" @click="showShowTableColumn('equipmentProduction')">
					<i class="yicon yicon-config_column"></i>
				</el-button>
			</div>
		</div>
		<!-- 图表和表单 -->
		<div class="echart-table">
			<div class="table" v-loading="searchLoading">
				<el-table max-height="600" stripe v-if="show" :data="equipmentProduction.tableData" border size="mini"
					:row-style="{height:42+'px'}" :cell-style="{padding:0+'px'}"
					:header-cell-style="{background: '#F5F7FA', color:'#606266','font-weight':'700', height:'48px', padding:'0px'}"
					:show-overflow-tooltip="true" @header-dragend="headerDragend">
					<el-table-column :show-overflow-tooltip="true"
						v-for="(item, index) in filterEquipmentProductionTableColumn" :key="index" :prop="item.prop"
						:fixed="item.fixed" :label="$t(item.label)" :sortable="item.sortable" :width="item.width">
						<template slot-scope="scope">
							<span v-if="!['equipmentName', 'orgName', 'shiftName'].includes(item.prop)"
								style="color: #419FFF"
								@click="showProductionDetail(scope.row, item.prop)">{{ scope.row[item.prop] }}</span>
							<span v-else style="color: #606266">{{scope.row[item.prop]}}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<el-drawer :visible.sync="productionDetail.dialog" :direction="productionDetail.direction" size="60%">
			<!-- 弹框标题 -->
			<div slot="title">
				<span
					style="font-size: 18px;font-weight: 400;margin-left:20px;color:#303133;">{{ $t(productionDetail.title) }}</span>
			</div>
			<div class="production-detail">
				<!-- 设备信息 -->
				<div class="equip-info">
					<div>{{ $t('shebeimingcheng') }} {{ $t(productionDetail.info.sn) }}</div>
					<div>{{ $t('riqi') }} {{ $t(productionDetail.info.time) }}</div>
					<div>{{ $t('banci') }} {{ $t(productionDetail.info.shiftName) }}</div>
				</div>
				<!-- 时间信息 -->
				<div class="time-info">
					<div class="item">
						<div class="title">
							<div class="sign color-green"></div>
							<div class="txt">{{ $t('yunxingshijian') }}(H)</div>
						</div>
						<div class="num">
							{{ productionDetail.info.runDuration || '--' }}
						</div>
					</div>
					<div class="item">
						<div class="title">
							<div class="sign color-orange"></div>
							<div class="txt">{{ $t('kongxianshijian') }}(H)</div>
						</div>
						<div class="num">
							{{ productionDetail.info.idleDuration || '--' }}
						</div>
					</div>
					<div class="item">
						<div class="title">
							<div class="sign color-red"></div>
							<div class="txt">{{ $t('guzhangshijian') }}(H)</div>
						</div>
						<div class="num">
							{{ productionDetail.info.errorDuration || '--' }}
						</div>
					</div>
					<div class="item">
						<div class="title">
							<div class="sign color-gray"></div>
							<div class="txt">{{ $t('lixianshijian') }}(H)</div>
						</div>
						<div class="num">
							{{ productionDetail.info.shutdownDuration || '--' }}
						</div>
					</div>
				</div>
				<div>
					<div id="efficiencyMonthlyStatusChart" :style="{'height':chartHeight2+'px'}"
						style="margin-top: 8px;width:100%">
					</div>
				</div>
				<!-- 表格 -->
				<div class="table">
					<el-table :data="productionDetail.tableData" border size="mini" :row-style="{height:42+'px'}"
						:cell-style="{padding:0+'px'}"
						:header-cell-style="{color:'#606266','font-weight':'700', height:'48px', padding:'0px'}">
						<el-table-column type="expand">
							<template slot-scope="scope">
								<div class="main">
									<div class="item">
										<div class="label">{{ $t('moqiangshu') }}</div>
										<div class="value" style="color: #606266;">{{ scope.row.mouldCavity }}</div>
									</div>
									<div class="item">
										<div class="label">{{ $t('lilunchanliang') }}</div>
										<div class="value" style="color: #606266;">
											{{(scope.row.theoryProduction)==null|| 0 ? '-':scope.row.theoryProduction}}
										</div>
									</div>
									<div class="item">
										<div class="label">{{ $t('shijishichang') }}</div>
										<div class="value" style="color: #606266;">
											{{((scope.row.duration)/3600).toFixed(1)}}
										</div>
									</div>
									<div class="item">
										<div class="label">{{ $t('dangbanleijichanliang') }}</div>
										<div class="value" style="color: #606266;">{{scope.row.shiftTotalProduction}}
										</div>
									</div>
									<div class="item">
										<div class="label">{{ $t('biaozhunzhouqi') }}({{$t('miao')}})</div>
										<div class="value" style="color: #606266;">
											{{scope.row.cycle== null|| 0 ? '-' :(scope.row.cycle).toFixed(1)}}
										</div>
									</div>
									<div class="item">
										<div class="label">{{ $t('jihuachanliang') }}</div>
										<div class="value" style="color: #606266;">
											{{(scope.row.planProduction)== null || '' ? 0 :scope.row.planProduction}}
										</div>
									</div>
									<div class="item">
										<div class="label">{{ $t('shebeipanduanbuliangshu') }}</div>
										<div class="value" style="color: #606266;">{{scope.row.defectiveQuantity}}</div>
									</div>
									<div class="item">
										<div class="label">{{ $t('picidachenglu') }}</div>
										<div class="value" style="color: #606266;">
											<el-progress style="width:139px;height:8px;font-size:10px;"
												:percentage="scope.row.batchCompletionRate == null ? 0 : Number((scope.row.batchCompletionRate/100)).toFixed(1)">
											</el-progress>
										</div>
									</div>
									<div class="item">
										<div class="label">{{ $t('dangbanbulianglu') }}</div>
										<div class="value">
											<div class="value" style="color: #606266;">
												{{scope.row.defectiveRate == null ? 0 : Number(((scope.row.defectiveRate)/100)).toFixed(1)}}<span
													style="color: #606266;">%</span>
											</div>
										</div>
									</div>
									<div class="item"></div>
								</div>
							</template>
						</el-table-column>
						<el-table-column v-for="(item, index) in productionDetail.tableColumn" :key="index"
							:prop="item.prop" :label="$t(item.label)"></el-table-column>
					</el-table>
				</div>
			</div>
		</el-drawer>
		<!-- 自定义显示项 -->
		<el-dialog :title="$t(showTableColumn.title)" :visible.sync="showTableColumn.dialog" width="720px">
			<!-- 产品月报 -->
			<template v-if="showTableColumn.type === 'equipmentProduction'">
				<el-transfer :titles="[$t('yincanglie'), $t('xianshilie')]"
					v-model="showTableColumn.equipmentProduction.show" :format="{
          noChecked: '${total}',
          hasChecked: '${total}'
        }" :data="equipmentProduction.tableColumn">
					<span slot-scope="{ option }"> {{ $t(option.label) }}</span>
				</el-transfer>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	const date = new Date()
	const year = date.getFullYear()
	const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
	const current = year + '-' + month

	const startTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01'
	const endTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
	export default {
		name: 'web_report_producee_report_production_monthly',
		components: {

		},
		data() {
			return {
        screenWidth: '', // 可视窗口的宽度
				searchLoading: false,
				exportLoading: false,
				currentStart: '',
				currentEnd: '',
				chartValueData: [],
				chartHeight2: 120,
				fildIds: '',
				timer: null,
				chart: null,
				options2: null,
				statusColors: {
					"0": "#67C23A",
					"3": "#F56C6C",
					"1": "#E6A23C",
					"-1": "#909399",
				},
				show: true,
				activeName: 'second',
				// 产量月报
				equipmentProduction: {
					searchForm: {
						time: current,
						orgId: [],
						equipmentId: []
					},
					tableData: [],
					tableColumn: [{
							label: this.$t("shebeimingcheng"),
							prop: 'equipmentName',
							width: "160",
							sortable: true,
							key: 0,
							fixed: true,
						},
						{
							label: this.$t("suoshuzuzhi"),
							prop: 'orgName',
							width: "150",
							key: 1,
							fixed: true,
						},
						{
							label: this.$t("banci"),
							prop: 'shiftName',
							width: "120",
							sortable: true,
							key: 2,
							fixed: true,
						}
					],

				},
				// 产品详情
				productionDetail: {
					dialog: false,
					direction: 'rtl',
					title: this.$t('chanliangxiangqing'),

					tableColumn: [{
							label: 'muhao',
							prop: 'mould',
							width: 150
						},
						{
							label: 'kaishishijian',
							prop: 'startTime',
							width: 150
						},
						{
							label: 'jieshushijian',
							prop: 'endTime',
							width: 150
						},
						{
							label: 'dangbanchanliang',
							prop: 'shiftProduction',

						}
					],
					tableData: [],
					info: {
						sn: '',
						time: '',
						shiftName: '',
						runDuration: '', // 运行时间
						idleDuration: '',
						errorDuration: '',
						shutdownDuration: ''
					}
				},
				showTableColumn: {
					dialog: false,
					title: 'peizhixianshilie',
					type: 'equipmentProduction',
					// 产品月报
					equipmentProduction: {
						show: [0, 1, 2],
						initShow: [],
					},
				},
			}
		},
		computed: {
			filterEquipmentProductionTableColumn() {
				let tableColumn = []
				for (let i = 0; i < this.equipmentProduction.tableColumn.length; i++) {
					if (this.showTableColumn.equipmentProduction.show.includes(this.equipmentProduction.tableColumn[i][
							'key'
						])) {
						tableColumn.push(this.equipmentProduction.tableColumn[i])
					}
				}
				const name = 'producee_report_second'
				let colwidths = {}
				if (window.localStorage.getItem("colwidth_" + name)) {
					try {
						colwidths = JSON.parse(window.localStorage.getItem("colwidth_" + name))
					} catch (e) {
						window.localStorage.removeItem("colwidth_" + name)
					}
				}
				if (tableColumn.length > 0) {
					for (const i in tableColumn) {
						if (colwidths[this.$t(tableColumn[i]['label'])] !== undefined) {
							this.$set(tableColumn[i], 'width', colwidths[this.$t(tableColumn[i]['label'])])
						}
					}
				}
				return tableColumn
			},
		},
		created() {
			setTimeout(() => {
				this.getEquipmentBasicReport();
			}, 300)
		},
		mounted() {
			this.initchart()
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		activated() {
			this.resize()
		},
		destroyed() {
			clearTimeout(this.timer)
		},
		watch: {
			radio(newValue, oldValue) {
				this.resize()
			}
		},
		methods: {
			getMonthLength(date) {
				let d = new Date(date)
				// 将日期设置为下月一号
				d.setMonth(d.getMonth() + 1)
				d.setDate('1')
				// 获取本月最后一天
				d.setDate(d.getDate() - 1)
				return d.getDate()
			},
			// 产量月报
			async getEquipmentBasicReport() {
				this.show = false;
				this.searchLoading = true;
				
				this.equipmentProduction.tableColumn = [{
						label: 'shebeimingcheng',
						prop: 'equipmentName',
						width: "160",
						sortable: true,
						fixed: true,
						key: 0,
					},
					{
						label: 'suoshuzuzhi',
						prop: 'orgName',
						width: "150",
						sortable: false,
						fixed: true,
						key: 1,
					},
					{
						label: 'banci',
						prop: 'shiftName',
						width: "120",
						sortable: true,
						fixed: true,
						key: 2
					}
				]
				let requestParam = {}
				let param = []
				const maxDay = this.getMonthLength(this.equipmentProduction.searchForm['time'])
				for (let i in this.equipmentProduction.searchForm) {
					if (this.equipmentProduction.searchForm[i] != "" && this.equipmentProduction.searchForm[i] !=
						null) {
						let val = this.equipmentProduction.searchForm[i]
						console.log("aaaa", this.equipmentProduction.searchForm[i])
						if (i == 'equipmentId') {
							val = this.equipmentProduction.searchForm[i].join(',')
							param.push({
								field: 'equipmentId',
								opt: "IN",
								val: val,
								type: "S"
							})
						}
						if (i == 'orgId') {
							val = this.equipmentProduction.searchForm[i].join(',')
							param.push({
								field: 'orgId',
								opt: "IN",
								val: val,
								type: "S"
							})
						}
						if (i == 'time') {
							val = this.equipmentProduction.searchForm[i].split('-')
							param.push({
								field: 'year',
								opt: "=",
								val: val[0],
								type: "S"
							})
							param.push({
								field: 'month',
								opt: "=",
								val: val[1] >= 10 ? val[1] : val[1].slice(-1),
								type: "S"
							})
							continue;
						}
					}
				}
				if (param.length > 0) {
					requestParam['columns'] = param
				} else {
					requestParam['columns'] = []
				}
				requestParam['code'] = "equipment_basic_production_report";
				let response = await this.http.post('/web/report/page?orderBy=sort asc', requestParam);
				this.equipmentProduction.tableData = response.data.rows;
				if (this.equipmentProduction.tableData.length > 0) {
					let res = this.equipmentProduction.tableData[0]
					let month = res['month']
					let column = []
					let key = 3
					for (let i in res) {
						if (/^date/.test(i)) {
							if (i.substr(4) > maxDay) {
								continue
							}
							column.push({
								key: key,
								label: month + '/' + i.substr(4),
								prop: i,
								num: parseInt(i.substr(4)),
								width: "90",
								sortable: true
							})
							this.showTableColumn.equipmentProduction.show.push(key);
							++key;
						}
					}
					this.showTableColumn.equipmentProduction.initShow = [...this.showTableColumn.equipmentProduction.show];
					column.sort(this.sortData);
					for (let i = 0; i < column.length; i++) {
						this.equipmentProduction.tableColumn.push(column[i])
					}
				} else {
					let key = 3
					let val = this.equipmentProduction.searchForm['time'].split('-')
					for (let i = 1; i <= maxDay; i++) {
						this.equipmentProduction.tableColumn.push({
							key: key,
							label: (val[1] >= 10 ? val[1] : val[1].slice(-1)) + '/' + (i > 10 ? i : '0' + i),
							prop: String(i),
							width: "90",
							sortable: true
						});
						++key;
					}
				}
				this.searchLoading = false;
				this.show = true;
			},
			// 排序
			sortData(a, b) {
				return a.num - b.num
			},
			// 产量月报基础表导出
			exportBasicProductionExcel() {
				this.exportLoading = true;
				let requestParam = {};
				let param = [];
				for (let i in this.equipmentProduction.searchForm) {
					if (this.equipmentProduction.searchForm[i] != "") {
						let val = this.equipmentProduction.searchForm[i]
						if (i == 'equipmentId') {
							val = this.equipmentProduction.searchForm[i].join(',')
							param.push({
								field: 'equipmentId',
								opt: "IN",
								val: val,
								type: "S"
							})
						}
						if (i == 'orgId') {
							val = this.equipmentProduction.searchForm[i].join(',')
							param.push({
								field: 'orgId',
								opt: "IN",
								val: val,
								type: "S"
							})
						}
						if (i == 'time') {
							val = this.equipmentProduction.searchForm[i].slice(0, 4) + this.equipmentProduction.searchForm[
								i].slice(4)
							param.push({
								field: 'specificdate',
								opt: "=",
								val: val,
								type: "S"
							})
						}
					}
				}
				if (param.length > 0) {
					requestParam['columns'] = param
				} else {
					requestParam['columns'] = []
				}
				requestParam['code'] = "equipment_basic_production_export"
				return this.http.post('/web/report/export?orderBy=sort,shiftName,summaryDate asc', requestParam).then(response => {
					let fildId = response.data
					return this.http.get('/web/report/work/get', {
						params: {
							id: fildId
						}
					}).then(response => {
						this.exportLoading = false;
						this.fildIds = response.data.fileId;
						let status = response.data.status;
						if (status == 1) {
							this.getDownload()
							this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
							this.$message.success(this.$t(response.msg))
						} else if (status == -1) {
							this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
							this.$message.success(this.$t(response.msg))
						} else if (status == 0 || null) {
							this.timer = setInterval(() => {
								this.getDownload()
							}, 1000);
						}
					});
				}).catch(error => {
					this.$message.error(this.$t(error));
					this.exportLoading = false;
				});
			},
			getDownload() {
				return this.http.get('/web/customer/files/download?id=' + this.fildIds).then(res => {
					let baseUrl = res.data
					if (res.data) {
						window.open(baseUrl)
					}
				})
			},
			//  重置产量月报
			resetEquipmentProduction() {
				this.equipmentProduction.searchForm = {
					time: current,
					orgId: '',
					equipmentId: null
				}
				this.getEquipmentBasicReport()
			},
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {
					this.screenWidth = document.body.clientWidth
				}, 500)
			},
			// 显示选择项
			showShowTableColumn(type) {
				this.showTableColumn.type = type
				this.showTableColumn.dialog = true
			},
			// 取消选择项
			cancelShowTableColumn() {
				this.showTableColumn.show = [...this.showTableColumn.initShow]
				this.showTableColumn.dialog = false
			},
			headerDragend(newWidth, oldWidth, column, event) {
				const name = 'producee_report_' + this.activeName
				let colwidths = {}
				if (window.localStorage.getItem("colwidth_" + name)) {
					try {
						colwidths = JSON.parse(window.localStorage.getItem("colwidth_" + name))
					} catch (e) {
						window.localStorage.removeItem("colwidth_" + name)
					}
				}
				if (column.label == "" || column.label == null) {
					return
				}
				colwidths[column.label] = column.width
				window.localStorage.setItem("colwidth_" + name, JSON.stringify(colwidths))
			},
			// 打开产品详情弹框
			async showProductionDetail(row, date) {
        console.log('row',row)
				if (this.chart) {
					this.chart.dispose();
					this.chart = null
				}
				this.productionDetail.info.sn = row.equipmentName
				this.productionDetail.info.time = row.year + '/' + row.month + '/' + date.substr(date.length - 2)
				this.productionDetail.info.shiftName = row.shiftName
				let runDuration = 0;
				let idleDuration = 0;
				let errorDuration = 0;
				let shutdownDuration = 0;
        console.log('dddfdfffff',this.productionDetail.info.time)
				let startTimes = (new Date(row.year + '-' + row.month + '-' + date.substr(date.length - 2) +
						' 00:00:00'))
					.getTime()
				let endTimes = (new Date(row.year + '-' + row.month + '-' + date.substr(date.length - 2) +
						' 23:59:59'))
					.getTime()
				let requestParams = {
					equipmentId: row.equipmentId,
					shiftId: row.shiftId,
					summaryDateStart: startTimes,
					summaryDateEnd: endTimes
				}
				this.http.get('/web/report/page/equipment_basic_production_details?' + this.qs.stringify(
					requestParams)).then(res => {
					this.currentStart = res.data.extend.shiftTime.startTime
					this.currentEnd = res.data.extend.shiftTime.endTime
					this.productionDetail.dialog = true
					this.productionDetail.tableData = res.data.rows
					this.tableCustomerInformationDate = res.data.records;
					console.log('this.currentStart', this.currentStart)
					console.log('this.currentEnd', this.currentEnd)
					let params = {
						equipmentId: row.equipmentId,
						startTime: this.currentStart,
						endTime: this.currentEnd
					}
					//图表
					let arr = []
					let b = 0
					this.http.get('/web/equipment/getEquipmentShitState/history?' + this.qs.stringify(
						params)).then(res => {
						res.data.map(item => {
							arr.push(((this.dayjs(item.et).unix() - this.dayjs(item.st)
								.unix()) / 3600))
						})
						console.log('arr', arr)
						let sum = arr.reduce((x, y) => {
							return x + y
						})
						this.chartValueData = res.data.map(item => {
							if (sum > 12) {
								item.last = (((this.dayjs(item.et).unix() - this.dayjs(item.st)
									.unix()) / 3600)) - 0.001
							} else {
								item.last = (((this.dayjs(item.et).unix() - this.dayjs(item.st)
									.unix()) / 3600))
							}

							console.log('item.last', item.last)
							return {
								s: item.s,
								st: item.st,
								et: item.et,
								name: '',
								type: 'bar',
								stack: 'total',
								label: {
									show: false
								},
								emphasis: {
									focus: 'series'
								},
								itemStyle: {
									normal: {
										color: this.statusColors[item.s],
										barBorderRadius: 0,
									},
								},
								data: [item.last],
							}

						})
						setTimeout(() => {
							this.initchart()
						}, 100)

					}).catch(error => {
						this.$message.error(this.$t(error))
					})

					let dataItem = res.data.extend.details
					if (dataItem.length > 0) {
						for (let item of dataItem) {
							runDuration += item.runDuration
							idleDuration += item.idleDuration
							errorDuration += item.errorDuration
							shutdownDuration += item.shutdownDuration

						}
						if (this.productionDetail.tableData.length > 0) {
							for (let i = 0; i < this.productionDetail.tableData.length; i++) {
								//时间处理
								this.productionDetail.tableData[i]['startTime'] = this.dateFormat(this
									.productionDetail
									.tableData[i]
									['startTime'])
								this.productionDetail.tableData[i]['endTime'] = this.dateFormat(this
									.productionDetail
									.tableData[i][
										'endTime'
									])
							}
						}

						this.productionDetail.info.runDuration = Number.isNaN(runDuration) == true ? '--' : (
								(runDuration /
									3600) / 1000)
							.toFixed(1)
						this.productionDetail.info.idleDuration = Number.isNaN(idleDuration) == true ? '--' : (
								(idleDuration / 3600) / 1000)
							.toFixed(1)
						this.productionDetail.info.errorDuration = Number.isNaN(errorDuration) == true ? '--' :
							((errorDuration / 3600) / 1000).toFixed(1)
						this.productionDetail.info.shutdownDuration = Number.isNaN(shutdownDuration) == true ?
							'--' : ((shutdownDuration / 3600) / 1000).toFixed(1)
					}
				}).catch(error => {
					this.$message.error(this.$t(error))
				})

			},
			initchart() {
				this.option = {
					tooltip: {
						show: false,
						trigger: 'axis',
						axisPointer: {
							// Use axis to trigger tooltip
							type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
						}
					},
					legend: {
						show: false,
					},
					grid: {
						top: '10',
						left: '-1',
						right: '6%',
						bottom: '30',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						minInterval: 1,
						maxInterval: 1,
						axisLabel: {
							formatter: (value, index) => {
								if (this.chartValueData) {
									console.log('qqqq', this.dayjs(this.chartValueData[0].st).hour() + index)
									return ((this.dayjs(this.chartValueData[0].st).hour() + (index)) % 24)
								}
								return "-"
							}

						}
					},
					yAxis: {
						show: false,
						type: 'category',
					},
					series: this.chartValueData,
				};
				this.$nextTick(() => {
					console.log('chartValueData', this.chartValueData)
					var chartDom = document.getElementById('efficiencyMonthlyStatusChart');
					this.chart = this.echarts.init(chartDom);
					this.option && this.chart.setOption(this.option);
				})


			},
			// 日期转换
			dateFormat(time) {
				const t = new Date(time)
				// 日期格式
				const format = 'Y-m-d h:i:s'
				let year = t.getFullYear()
				// 由于 getMonth 返回值会比正常月份小 1
				let month = t.getMonth() + 1
				let day = t.getDate()
				let hours = t.getHours()
				let minutes = t.getMinutes()
				let seconds = t.getSeconds()
				month = month > 9 ? month : `0${month}`
				day = day > 9 ? day : `0${day}`
				hours = hours > 9 ? hours : `0${hours}`
				minutes = minutes > 9 ? minutes : `0${minutes}`
				seconds = seconds > 9 ? seconds : `0${seconds}`
				const hash = {
					'Y': year,
					'm': month,
					'd': day,
					'h': hours,
					'i': minutes,
					's': seconds
				}
				return format.replace(/\w/g, o => {
					return hash[o]
				})
			},
			dateItemFormat(time) {
				const t = new Date(time)
				// 日期格式
				const format = 'Y-m-d'
				let year = t.getFullYear()
				// 由于 getMonth 返回值会比正常月份小 1
				let month = t.getMonth() + 1
				let day = t.getDate()
				month = month > 9 ? month : `0${month}`
				day = day > 9 ? day : `0${day}`
				const hash = {
					'Y': year,
					'm': month,
					'd': day,
				}
				return format.replace(/\w/g, o => {
					return hash[o]
				})
			},
		}
	}
</script>
